import {
	assertDeploymentHostMatchesEnvironment,
	resolveDeploymentEnvironment,
} from './environment';

interface ApiEndpoint {
	[key: string]: string;
}

interface nodeType {
	[key: string]: ApiEndpoint;
}

export const stripePaymentsEnabledForDevelopment = (): boolean =>
	String(process.env.REACT_APP_STRIPE_PAYMENTS_ENABLED || '')
		.trim()
		.toLowerCase() === 'true';

const currentEnv = resolveDeploymentEnvironment(
	process.env.NODE_ENV,
	process.env.REACT_APP_DEPLOY_ENV,
);

const envConfig: nodeType = {
	development: {
		// API_ENDPOINT: 'https://api.staging.scrubplan.com/',
		API_ENDPOINT: 'http://localhost:8001/',
		STRIPE_PUBLIC_KEY:
			'pk_test_51KsNCrJXaxzVFlMZgX21Z8makMReJt27kLovNnkL62gHOUwVQi1lXYlX97jpRnRMc296kbugSS0QSBy2nPidNIRx00YpStl17J',
		STRIPE_PAYMENTS_ENABLED: stripePaymentsEnabledForDevelopment() ? 'true' : 'false',
		IDENTITY_POOL_ID: 'us-east-1:48b8fb31-6245-42e7-8d1e-8138cc8c0b86', // 'us-east-1:b8fa08f9-5ceb-464a-aa08-8ce437d987c1',
		BUCKET_NAME: 'scrubplan-staging-pdf-upload-bucket',
		SPEC_BUCKET_NAME: 'scrubplan-staging-spec-summary-pdf-upload-bucket',
		BUCKET_REGION: 'us-east-1',
		TRADE_DOWNLOAD: 'https://scrub-plan-prod-download.s3.amazonaws.com/tradeuploadTemplate.xlsx',
		SCOPE_DOCUMENT_PROMPT_DOWNLOAD:
			'https://scrub-plan-prod-download.s3.us-east-1.amazonaws.com/scopeDocumentPromptUploadTemplate.xlsx',
		MS_CLIENT_ID: 'ebbf3a4d-107a-4f1d-a958-985ddf0150c4',
	},
	qa: {
		API_ENDPOINT: 'https://api.staging.scrubplan.com/',
		STRIPE_PUBLIC_KEY:
			'pk_test_51KsNCrJXaxzVFlMZgX21Z8makMReJt27kLovNnkL62gHOUwVQi1lXYlX97jpRnRMc296kbugSS0QSBy2nPidNIRx00YpStl17J',
		IDENTITY_POOL_ID: 'us-east-1:b8fa08f9-5ceb-464a-aa08-8ce437d987c1',
		BUCKET_NAME: 'scrubplan-staging-pdf-upload-bucket',
		SPEC_BUCKET_NAME: 'scrubplan-staging-spec-summary-pdf-upload-bucket',
		BUCKET_REGION: 'us-east-1',
		TRADE_DOWNLOAD: 'https://scrub-plan-prod-download.s3.amazonaws.com/tradeuploadTemplate.xlsx',
		SCOPE_DOCUMENT_PROMPT_DOWNLOAD:
			'https://scrub-plan-prod-download.s3.us-east-1.amazonaws.com/scopeDocumentPromptUploadTemplate.xlsx',
		MS_CLIENT_ID: 'ebbf3a4d-107a-4f1d-a958-985ddf0150c4',
	},
	staging: {
		// API_ENDPOINT: 'http://localhost:8001/',
		API_ENDPOINT: 'https://api.staging.scrubplan.com/',
		STRIPE_PUBLIC_KEY:
			'pk_test_51KsNCrJXaxzVFlMZgX21Z8makMReJt27kLovNnkL62gHOUwVQi1lXYlX97jpRnRMc296kbugSS0QSBy2nPidNIRx00YpStl17J',
		IDENTITY_POOL_ID: 'us-east-1:48b8fb31-6245-42e7-8d1e-8138cc8c0b86',
		BUCKET_NAME: 'scrubplan-staging-pdf-upload-bucket',
		SPEC_BUCKET_NAME: 'scrubplan-staging-spec-summary-pdf-upload-bucket',
		BUCKET_REGION: 'us-east-1',
		TRADE_DOWNLOAD: 'https://scrub-plan-prod-download.s3.amazonaws.com/tradeuploadTemplate.xlsx',
		SCOPE_DOCUMENT_PROMPT_DOWNLOAD:
			'https://scrub-plan-prod-download.s3.us-east-1.amazonaws.com/scopeDocumentPromptUploadTemplate.xlsx',
		MS_CLIENT_ID: 'ebbf3a4d-107a-4f1d-a958-985ddf0150c4',
	},
	production: {
		API_ENDPOINT: 'https://api.scrubplan.com/',
		STRIPE_PUBLIC_KEY:
			'pk_live_51ILKDvJpM9YsyIVgaLSDqvoC5q7TOxA3mlBYNrm7AcyXSIvcnU4viS0gc4hmXKvpeBJW3OuQ8q5HwcVrhSgbMYvd00hdL38xNR',
		IDENTITY_POOL_ID: 'us-east-1:b8fa08f9-5ceb-464a-aa08-8ce437d987c1',
		BUCKET_NAME: 'scrub-plan-prod-pdf-upload-bucket',
		SPEC_BUCKET_NAME: 'scrub-plan-prod-spec-summary-pdf-upload-bucket',
		BUCKET_REGION: 'us-east-1',
		TRADE_DOWNLOAD: 'https://scrub-plan-prod-download.s3.amazonaws.com/tradeuploadTemplate.xlsx',
		SCOPE_DOCUMENT_PROMPT_DOWNLOAD:
			'https://scrub-plan-prod-download.s3.us-east-1.amazonaws.com/scopeDocumentPromptUploadTemplate.xlsx',
		MS_CLIENT_ID: 'b019e939-1261-4603-98ba-75117a22d9f7',
	},
};

assertDeploymentHostMatchesEnvironment(
	currentEnv,
	typeof window === 'undefined' ? '' : window.location.hostname,
);

export default envConfig[currentEnv];
